import { DatadogInitModel } from '@cw-elements/analytics-provider';

import { handleBeforeSend } from './datadog-rum.utils';

// `service`, `env` and `version` are mandatory for the analytics provider: they are
// the RUM tags that scope every session to a deployable unit and release. When any of
// them resolves to an empty value the provider skips RUM init and only logs to the
// console, so they must come from the build rather than be hardcoded.
const DATADOG_RUM_CONFIG: DatadogInitModel = {
  applicationId: import.meta.env.VITE_DATA_DOG_APPLICATION_ID,
  clientToken: import.meta.env.VITE_DATA_DOG_CLIENT_TOKEN,
  site: 'datadoghq.eu',
  service: 'web-react-cropwise-fms',
  env: import.meta.env.VITE_APP_ENV,
  version: import.meta.env.VITE_APP_VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: 'allow',
  silentMultipleInit: true,
  telemetrySampleRate: 100,
  traceSampleRate: 100,
  allowedTracingUrls: [
    import.meta.env.VITE_FMS_API_URL,
    import.meta.env.VITE_BASE_API_URL,
  ]
    .filter(Boolean)
    .map((apiUrl) => ({
      match: apiUrl,
      propagatorTypes: ['datadog' as const],
    })),
  traceContextInjection: 'sampled',
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  enablePrivacyForActionName: false,
  compressIntakeRequests: true,
  beforeSend: handleBeforeSend,
};

export { DATADOG_RUM_CONFIG };
